var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17,
    stroke: "#434289"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6067 18.2071C26.9972 17.8166 26.9972 17.1834 26.6067 16.7929L20.2428 10.4289C19.8522 10.0384 19.2191 10.0384 18.8285 10.4289C18.438 10.8195 18.438 11.4526 18.8285 11.8431L24.4854 17.5L18.8285 23.1569C18.438 23.5474 18.438 24.1805 18.8285 24.5711C19.2191 24.9616 19.8522 24.9616 20.2428 24.5711L26.6067 18.2071ZM9.09961 18.5L25.8996 18.5L25.8996 16.5L9.09961 16.5L9.09961 18.5Z",
    fill: "#434289"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrow);
export default __webpack_public_path__ + "static/media/slider-arrow.d2a6bc8a23ba51a6fd78852c06951c93.svg";
export { ForwardRef as ReactComponent };